module.exports = __webpack_public_path__ + "img/ic_mpe_chair_sm3_press.075dbe08.png";